import { TenantVM } from "@propertelligent/client-api";

type TenantWithPastDue = TenantVM & { pastDue?: number };

// Past Due = outstanding tenant dues with DueDate before today (TenantVM.PastDue), not IncomeDue,
// which also includes current and future dues.
export const getTenantPastDue = (tenant?: TenantVM | null): number =>
  Number((tenant as TenantWithPastDue | null | undefined)?.pastDue ?? 0);
